import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
  forwardRef
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

const noop = () => {};

@Component({
  selector: "mutliselect",
  templateUrl: "./mutliselect.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MutliselectComponent),
      multi: true
    }
  ]
})
export class MutliselectComponent
  implements OnInit, OnChanges, ControlValueAccessor {
  @Input() options: any[];
  @Input() viewMode: boolean;
  @Input() propertyToSelect: string;
  @Input() multiple: boolean;
  @Input() config: any;
  @Output() change = new EventEmitter<any>();

  obj: any = [];
  switch: boolean = false;
  _value;
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  ngOnInit() {}

  get Value() {
    return this._value;
  }

  set Value(val) {
    this._value = val;

    this.onChangeCallback(this._value);
    this.onTouchedCallback();
    this.change.emit(this._value);
  }

  writeValue(data: any): void {
    if (data !== undefined && data !== null) {
      this._value = data;
      if (this.options) {
        if (this.multiple) {
          this.obj = this.options.filter(s => {
            if (data.indexOf(s[this.propertyToSelect]) != -1) {
              return s;
            }
          });
        } else {
          this.obj = this.options.filter(s => {
            if (data == s[this.propertyToSelect]) {
              return s;
            }
          });
        }
      }
      if (this.obj == undefined) {
        this.switch = !this.switch;
      }
    }
    if (data === undefined || data === null) {
      this.obj = undefined;
      this.switch = !this.switch;
    }
  }

  registerOnChange(fn) {
    this.onChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  ngOnChanges(changes: any) {
    if (changes["options"] && this.options && this.Value) {
      if (this.multiple) {
        this.obj = this.options.filter(s => {
          if (this.Value.indexOf(s[this.propertyToSelect]) != -1) {
            return s;
          }
        });
      } else {
        this.obj = this.options.filter(s => {
          if (this.Value == s[this.propertyToSelect]) {
            return s;
          }
        });
      }
    }
  }

  onChangeHandler(event): void {
    if (this.multiple) {
      this.Value = this.obj.map(s => {
        return s[this.propertyToSelect];
      });
    } else {
      if (this.obj) {
        this.Value = this.obj[this.propertyToSelect];
      }
      if (!this.propertyToSelect) {
        this.Value = event;
      }
      if (!this.obj) {
        this.Value = null;
      }
    }
    this.change.emit(this.Value);
  }
}
